import type { SelectionAsRecord, YYYYMMDD } from '../../typings'

export const matchHighlightProducer = (map: SelectionAsRecord) => {
  return (date: YYYYMMDD): boolean => !!map[date]
}
